module.exports = __webpack_public_path__ + "static/img/cmef.de1ce33b.png";